export const EVENT_FILTER_DEBOUNCE_TIME_FAST = 500;
export const EVENT_FILTER_DEBOUNCE_TIME_SLOW = 2000;
